__turbopack_context__.v({
  "header": "style-module-scss-module__Ooia0G__header",
  "logoContainer": "style-module-scss-module__Ooia0G__logoContainer",
  "logoImage": "style-module-scss-module__Ooia0G__logoImage",
  "marketsImageMobile": "style-module-scss-module__Ooia0G__marketsImageMobile",
  "marketsMobileMenu": "style-module-scss-module__Ooia0G__marketsMobileMenu",
  "marketsWrapper": "style-module-scss-module__Ooia0G__marketsWrapper",
  "mobileMenu": "style-module-scss-module__Ooia0G__mobileMenu",
  "mobileMenuButton": "style-module-scss-module__Ooia0G__mobileMenuButton",
  "mobileMenuOpen": "style-module-scss-module__Ooia0G__mobileMenuOpen",
  "navContainer": "style-module-scss-module__Ooia0G__navContainer",
  "navItem": "style-module-scss-module__Ooia0G__navItem",
  "navItemActive": "style-module-scss-module__Ooia0G__navItemActive",
  "navMobileMenu": "style-module-scss-module__Ooia0G__navMobileMenu",
});
